// ============================================================
// mulberry32 - the one small seeded generator the engine uses.
//
// Three places needed a seeded generator that is not the dice (gotcha 5):
// the forecasts' own dice (probability.ts), the fuzzer's choices
// (fuzz/rng.ts, whose sessions replay from a seed) and the display's
// variety (display/rng.ts). They were three copies of this step; this is
// the one, unchanged to the bit, so every replay still replays.
//
// Not cryptographic, and never the game's dice. Pure.
// ============================================================

/** One step: the next state, and a float in [0, 1). */
export function mulberry32Step(state: number): { state: number; value: number } {
  const s = (state + 0x6d2b79f5) >>> 0;
  let t = s;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return { state: s, value: ((t ^ (t >>> 14)) >>> 0) / 4294967296 };
}

/** A generator in [0, 1) from a 32-bit seed. */
export function mulberry32(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    const step = mulberry32Step(state);
    state = step.state;
    return step.value;
  };
}
